import axios from 'axios';

// Cache variables for list() endpoint
let _listCache = null;
let _listCacheTime = 0;
const LIST_CACHE_TTL = 3600; // 1 hour in seconds

export default {
    list() {
        const now = Date.now() / 1000;
        if (_listCache && (now - _listCacheTime < LIST_CACHE_TTL)) {
            return Promise.resolve(_listCache);
        }
        return axios.get('[API]/product-type-groups/list').then((response) => {
            _listCache = response;
            _listCacheTime = now;
            return response;
        });
    },
    clearListCache() {
        _listCache = null;
        _listCacheTime = 0;
    },
    bulkUpdate(groups) {
        return axios.post('[API]/product-type-groups/bulk-update', { groups }).then((response) => {
            this.clearListCache();
            return response;
        });
    },
    create(data) {
        return axios.post('[API]/product-type-groups', data, {
            headers: {
                'X-No-Snake-Case-Paths': 'name.translations.*',
            },
        }).then((response) => {
            this.clearListCache();
            return response;
        });
    },
    update(data) {
        return axios.put(`[API]/product-type-groups/${data.id}`, data, {
            headers: {
                'X-No-Snake-Case-Paths': 'name.translations.*',
            },
        }).then((response) => {
            this.clearListCache();
            return response;
        });
    },
    merge(data) {
        return axios.post('[API]/product-type-groups/merge', data).then((response) => {
            this.clearListCache();
            return response;
        });
    },
    destroy(id) {
        return axios.delete(`[API]/product-type-groups/${id}`).then((response) => {
            this.clearListCache();
            return response;
        });
    },
};
